import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { t } from 'src/app/shared/_helpers/translation.helper';
import { TenantService } from 'src/app/_services/tenant.service';
import { TokenService } from 'src/app/_services/token.service';
import { UserType } from 'src/app/_admin/user-managment/models/UserManagementDTO';

@Component({
  selector: 'app-manage-access-page',
  templateUrl: './manage-access-page.component.html',
  styleUrl: './manage-access-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ManageAccessPageComponent implements OnInit {
  isUserManagement = false;
  isPartnerAdmin = false;
  isTenantAdmin = false;

  constructor(
    private router: Router,
    private tenantService: TenantService,
    private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.isUserManagement = this.router.url.includes('/benutzermanagement');

    if (this.isUserManagement) {
      this.tenantService.GetUserTenants().subscribe((tenants) => {
        const currentTenantName = this.tokenService.GetTenant();
        const currentTenant = tenants.find((t) => t.name === currentTenantName);
        this.isPartnerAdmin = tenants.some((t) => t.userType === UserType.PartnerAdmin);
        this.isTenantAdmin = currentTenant?.userType === UserType.TenantAdmin;
      });
    }
  }

  get isAdminView(): boolean {
    return !this.isUserManagement;
  }

  tr(key: string, ...params: any[]): string {
    return t(key, this.isAdminView, ...params);
  }
}
